import emailjs from '@emailjs/browser';

const initializeEmailjs = () => {
  emailjs.init('bOkgMB9k6HDoHK5Cl');
};

export default initializeEmailjs;